import TourPermits from '../views/permits/TourPermits.vue'
import HeldPermits from '../views/permits/HeldPermits.vue'
import BookedPermits from '../views/permits/BookedPermits.vue'

import TourSchedule from '../views/reservations/TourSchedule.vue'
import TourItinerary from '../views/reservations/TourItinerary.vue'
import TourCosting from '../views/reservations/TourCosting.vue'
import BookingForm from '../views/reservations/BookingForm.vue'
import TourSummary from '../views/reservations/TourSummary.vue'

import FinanceInvoice from '../views/finance/FinanceInvoice.vue'
import FinanceQuotes from '../views/finance/FinanceQuotes.vue'
import FinancePayments from '../views/finance/FinancePayments.vue'

import OperationsBudgeting from '../views/operations/OperationsBudgeting.vue'
import OperationsSafaris from '../views/operations/OperationsSafaris.vue'
import OperationsAllocations from '../views/operations/OperationsAllocations.vue'
import OperationsRequisition from '../views/operations/OperationsRequisition.vue'
import OperationsPayments from '../views/operations/OperationsPayments.vue'



export default [
    // permits: [ "TourSchedulePermits", "ItineraryPermits", "FinancePaymentsPermits", // "FinanceInvoicesPermits", 
    // "TourPermits", "HeldPermits", "BookedPermits", ],
    {
        path: '/permits/schedule',
        name: 'TourSchedulePermits',
        component: TourSchedule
    },
    {
        path: '/permits/budgeting',
        name: 'PermitsBudgeting',
        component: OperationsBudgeting
    },
    {
        path: '/permits/requisitions',
        name: 'PermitsRequisition',
        component: OperationsRequisition
    },
    {
        path: '/permits/permits',
        name: 'AllPermits',
        component: TourPermits
    },
    {
        path: '/permits/booking',
        name: 'PermitsBooking',
        component: BookingForm
    },
    {
        path: '/permits/itinerary',
        name: 'ItineraryPermits',
        component: TourItinerary
    },
    {
        path: '/permits/invoices',
        name: 'PermitsInvoices',
        component: FinanceInvoice
    },
    {
        path: '/permits/payments',
        name: 'FinancePaymentsPermits',
        component: FinancePayments
    },
];